import classNames from 'classnames';
import { FC } from 'react';

import { Icon } from '@/shared/ui';

import styles from './counterBig.module.scss';

interface CounterBigProps {
  count?: number;
  increment?: () => void;
  decrement?: () => void;
  className?: string;
}

const CounterBig: FC<CounterBigProps> = (props) => {
  const { count = 1, increment, decrement, className } = props;
  return (
    <div className={classNames(styles.counter, className)}>
      <button
        aria-label="Уменьшить количество"
        className={styles.counter__btn}
        disabled={count < 1}
        type="button"
        onClick={decrement}
      >
        <Icon name="minusBig" />
      </button>
      <p className={styles.counter__text}>{count}</p>
      <button
        aria-label="Увеличить количество"
        className={styles.counter__btn}
        type="button"
        onClick={increment}
      >
        <Icon name="plusBig" />
      </button>
    </div>
  );
};

export default CounterBig;
